<template>
    <div class="home-about-section" v-if="indexPage != null">
        <div class="container">
            <div class="section-title">
                <h2>{{ indexPage.about_title }}</h2>
            </div>
            <div class="about-container">
                <div class="about-pic" :style="!isMobileChecker ? 'background-image: url(' + indexPage.about_img + ')' : 'background-image: url(' + indexPage.about_img_mobile + ')'">
                    <div class="logo-dial"><img :src="indexPage.about_logo" alt=""></div>
                    <div class="desc"><p v-html="indexPage.about_desc"></p></div>
                    <router-link :to="{ name: 'about'}" class="btn-more btn-wow-effect-hover">
                        <span v-if="globalLang == ''">Подробнее</span>
                        <span v-if="globalLang == 'kz/'">Толығырақ</span>
                        <svgIcon name="arrow-right" class="icon-right-arrow"/>
                    </router-link>
                </div>
                <div class="about-info-carousel" v-if="!isMobileChecker">
                    <div class="about-main-btn-prev slider-btn">
                        <svgIcon name="arrow-left" class="icon-left-arrow"/>
                    </div>
                    <div class="about-main-carousel">
                        <swiper :options="swiperOption" ref="promoCarousel">
                            <swiper-slide v-for="(slide, index) in indexPage.about_cards" :key="index">
                                <a href="#" @click.prevent>
                                    <div class="slide-info">
                                        <div class="slide-icon"><img :src="slide.icon" alt=""></div>
                                        <div class="slide-desc">
                                            <strong>{{ slide.info }}</strong>
                                            <p v-html="slide.desc"></p>
                                        </div>
                                    </div>
                                </a>
                            </swiper-slide>
                        </swiper>
                        <!-- <div class="swiper-pagination promo-pagination"></div> -->
                    </div>
                    <div class="about-main-btn-next slider-btn">
                        <svgIcon name="arrow-right" class="icon-right-arrow"/>
                    </div>
                </div>
                <div class="mobile-container-about" v-if="isMobileChecker">
                    <div class="item" v-for="(item, index) in indexPage.about_cards">
                        <div class="item-icon"><img :src="item.icon" alt=""></div>
                        <div class="item-desc">
                            <strong>{{ item.info }}</strong>
                            <p v-html="item.desc"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'home-about-section',
        components: {
            svgIcon,
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
                swiperOption: {
                    speed: 1000,
                    observer: true,
                    observeParents: true,
                    effect: 'slide',
                    slidesPerView: 3,
                    spaceBetween: 25,
                    simulateTouch: true,
                    watchSlidesVisibility: true,
                    loop: true,
                    navigation: {
                        nextEl: '.about-main-btn-next',
                        prevEl: '.about-main-btn-prev',
                    },
                    breakpoints: {
                        1200: {
                            slidesPerView: 3,
                            spaceBetween: 15
                        },
                    }
                },
            }
        },
        computed: mapGetters({
            indexPage: 'loadIndexPage',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/home-page/home-about.scss';
    @import '@/styles/components/home-page/respond/home-about-respond.scss';
</style>